import ConsumerGroupOffsetDelete from './ConsumerGroupOffsetDelete';

export default ConsumerGroupOffsetDelete;
